<template>
    <div class="box">
        <!--..右侧盒子..-->
        <div class="me_fabu">
            <div class="fabu_tit">
                <p>发布供应</p>
            </div>
            <!--..表单..-->
            <form v-loading="id > 0 && loading">
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>供应品类：</label>
                    <select name="side" v-model="model.category_id_1" style="width:133px" @change="getchildCategory(true)">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.category_id"  v-for="item in categoryList" :key="item.category_id">{{item.category_name}}</option>
                    </select>
                    <select name="side" v-model="model.category_id" style="width:133px" @change="getAttr(true)">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.category_id" v-for="item in childCategoryList" :key="item.category_id">{{item.category_name}}</option>
                    </select>
                    <select name="side" v-model="attr_value_id" style="width:133px" @change="test()">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.attr_value_id" v-for="item in attrList" :key="item.attr_value_id">{{item.attr_value_name}}</option>
                    </select>
                </p>
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>价格：</label>
                    <input type="text" @input="inputaction" v-model="minprice" placeholder='请输入最低价' style="width:100px" maxlength="9" />
                    <span style="margin-right: 7px;">-</span>
                    <input type="text" @input="inputaction" v-model="maxprice" placeholder='请输入最高价' style="width:100px" maxlength="9" />
                    <select @change="inputaction" name="side" style="width:100px" v-model="model.unit">
                        <option value="" disabled style="display:none">请选择</option>
                        <option :value="item.typename" v-for="item in units" :key="item.tid">元/{{item.typename}}</option>
                    </select>
                    
                    <label style="width:90px;margin-left: -10px;"> <input style="border:none" class="radio_type" v-model="isPriceEmpty" @change="changeaction" name="" type="radio" :value="true" />价格面议</label>
                </p>
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>所在地</label>
                    <select v-model="model.province_code" name="side" style="width:133px" @change="changeArea(2)">
                        <option value="" disabled style="display:none">请选择省</option>
                        <option :value="item.id" v-for="item in provinceList" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.city_code" name="side" style="width:133px" @change="changeArea(3)">
                        <option value="" disabled style="display:none">请选择市</option>
                        <option :value="item.id" v-for="item in cityList" :key="item.id">{{item.shortname}}</option>
                    </select>
                    <select v-model="model.district_code" name="side" style="width:133px">
                        <option value="" disabled style="display:none">请选择区/县</option>
                        <option :value="item.id" v-for="item in districtList" :key="item.id">{{item.shortname}}</option>
                    </select>
                </p>
                <p class="fabu_form_p01">
                    <label><span style="color:red">*</span>商品描述：</label><textarea style="width: 420px;height: 80px;border: #e4e4e4 1px solid;padding: 10px 0 0 10px;font-size: 14px;" type="text" v-model="model.remark" placeholder='请输入商品描述' maxlength="500" />
                </p>
                <p class="fabu_form_p01">
                    <label>商品图片：</label>
                    <section class='img_box'>
                        <el-upload
                        :action="uploadActionUrl"
                        :limit="imgCount"
                        :file-list="imgList"
                        :on-exceed="handleExceed"
                        list-type="picture-card"
                        accept=".jpg,.jpeg,.png,.gif,.bmp"
                        :on-preview="handlePictureCardPreview"
                        :on-success="handleSuccess"
                        :before-upload="beforeAvatarUpload"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible" ><img width="100%" :src="dialogImageUrl" alt="" ></el-dialog>
                    </section>
                </p>
                <p style="margin-top: 10px;" class="fabu_form_p01"><label></label>提示：图片请上传jpg/jpeg/png/gif/bmp类型的文件，最多上传1张，单张大小不超过5MB。</p>
                <!--...提交按钮..-->
                <a href="javascript:void(0)" v-if="id>0"><input type="button" id="" value="确认修改" @click="submit()" class="fabu_form_but" /></a>
                <a href="javascript:void(0)" v-else><input type="button" id="" value="确认发布" @click="submit()" class="fabu_form_but" /></a>
            </form>
        </div>
    </div>
</template>

<style scoped>
.radio_type {
    width: 20px;
    height: 20px;
    appearance: none;
    position: relative;
    outline: none;
}
.radio_type:before {
    content: "";
    width: 15px;
    height: 15px;
    border: 1px solid #999;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}
.radio_type:checked:before {
    content: "";
    width: 15px;
    height: 15px;
    border: 1px solid #39bf3e;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}
.radio_type:checked:after {
    content: "";
    width: 8px;
    height: 8px;
    text-align: center;
    background: #39bf3e;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 4px;
    left: 14px;
  
}
.radio_type:checked + label {
    color: #edd19d;
}
</style>

<script>

    import '@/assets/styles/css/common.css';
    import '@/assets/styles/css/me.css';
    import { publictypeList } from '@/api/publicType/publicType';
    import { getArea } from '@/api/address';
    import { getSelectList, getAttrValueList } from '@/api/goods/goodscategory';
    import { addsupply, editsupply, supplyDetail } from '@/api/supply/supply';
    import util from '@/utils/util.js';
    import Config from '@/utils/config';

    export default {
        name: "",
        components: {},
        data: () => {
            return {
                id:0,
                model:{category_id_1:'', category_id:'', attr_value_id:'', province_code:'', city_code:'', district_code:'', unit:''},
                minprice:'',
                maxprice:'',
                attr_value_id:'',
                loading:true,
                units:[],
                provinceList:[],
                cityList:[],
                districtList:[],
                categoryList:[],
                childCategoryList:[],
                attrList:[],
                isPriceEmpty: false,

                imgCount:1,
                imgList: [],
                dialogImageUrl: '',
			    dialogVisible: false,
                uploadActionUrl: Config.baseUrl + '/api/upload/supplyImg',
            }
        },
        created() {
            this.id = this.$route.query.id;
            if(this.id > 0) {
                this.getDetails();
            }
            this.getUnits();
            this.getAreas('', 1);
            this.getCategory();
        },
        methods: {
            inputaction() {
                this.isPriceEmpty = false;
            },
            changeaction() {
                if(this.isPriceEmpty) {
                    this.minprice = '';
                    this.maxprice = '';
                    this.model.unit = '';
                }
            },
            getDetails() {
                supplyDetail({
                    id: this.id
                }).then(res => {
                    if(res.code == 0) {
                        this.model = res.data;
                        console.log(this.model);
                        if(!util.isEmpty(this.model.unit)) {
                            let ulist = this.model.unit.split('/');
                            this.model.unit = ulist[1];
                        }
                        if(!util.isEmpty(this.model.image)) {
                            this.imgList.push({name:this.model.image,url:Config.baseUrl + this.model.image});
                            this.checkCount();
                        }
                        if(this.model.price == '面议') {
                            this.isPriceEmpty = true;
                        }
                        else{
                            if(this.model.price.indexOf('-') > -1) {
                                let pricelist = this.model.price.split('-');
                                this.minprice = pricelist[0];
                                this.maxprice = pricelist[1];
                            }
                            else {
                                this.minprice = this.model.price;
                            }
                        }
                        this.attr_value_id = this.model.attr_value_id;
                        var list = this.model.category_path.split(',');
                        this.model.category_id_1 = list[1];
                        //期望货源地
                        var areapathlist = this.model.areapath.split(';');
                        var codelist = [];
                        areapathlist.forEach(item => {
                            if(!util.isEmpty(item)) {
                                codelist.push(item);
                            }
                        });
                        this.model.province_code = codelist[0];
                        this.model.city_code = !util.isEmpty(codelist[1]) ? codelist[1] : "";
                        this.model.district_code = !util.isEmpty(codelist[2]) ? codelist[2] : "";
                        //this.changeArea(2);
                        this.getAreas(this.model.province_code, 2);
                        if(codelist.length>1) {
                            //this.changeArea(3);
                            this.getAreas(this.model.city_code, 3);
                        }
                        if(codelist.length>2) {
                        }

                        this.loading = false;
                    }
                }).catch(err => {
                    this.loading = false;
                    //this.$message.error(err);
                })
            },
            getUnits() {
                publictypeList({
                    typenumber: '10007',
                    level: 2
                }).then(res => {
                    if(res.code == 0) {
                        this.units = res.data;
                        // if(this.units.length>0) {
                        //     this.model.unit = this.units[0].typename;
                        // }
                    }
                })
            },
            getAreas(pid, level) {
                getArea({
                    pid: pid
                }).then(res => {
                    if(res.code == 0) {
                        switch(level)
                        {
                            case 1:
                                this.provinceList = res.data;
                                break;
                            case 2:
                                this.cityList = res.data;
                                break;
                            case 3:
                                this.districtList = res.data;
                                break;
                        }
                    }
                })
            },
            changeArea(level) {
                if(level == 2) {
                    this.model.city_code = '';
                    this.model.district_code = '';
                    this.districtList = [];
                    if(!util.isEmpty(this.model.province_code))
                    {
                        this.getAreas(this.model.province_code, 2);
                    }
                }
                else {
                    this.model.district_code = '';
                    if(!util.isEmpty(this.model.city_code))
                    {
                        this.getAreas(this.model.city_code, 3);
                    }
                }
                
            },
            getCategory() {
                getSelectList({
                    level:1
                }).then(res => {
                    if(res.code == 0) {
                        this.categoryList = res.data;
                        if(this.id>0) {
                            this.getchildCategory(false);
                            this.getAttr(false);
                        }
                    }
                });
            },
            getchildCategory(isclear) {
                this.attrList = [];
                if(isclear) {
                    this.model.category_id = '';
                }
                var _that = this;
                var list = this.categoryList.filter(function(item){
                    return item.category_id == _that.model.category_id_1;
                });
                if(list.length > 0 && !util.isEmpty(list[0].children)) {
                    this.childCategoryList = list[0].children;
                }
                else {
                    this.childCategoryList = [];
                }
            },
            getAttr(isclear) {
                if(isclear) {
                    this.model.attr_value_id = '';
                }
                var _that = this;
                var list = this.childCategoryList.filter(function(item){
                    return item.category_id == _that.model.category_id;
                });
                if(list.length > 0) {
                    getAttrValueList({
                        attr_class_id: list[0].attr_class_id
                    }).then(res => {
                        if(res.code == 0) {
                            this.attrList = res.data;
                        }
                    })
                }
            },
            test() {
                this.model.attr_value_id = this.attr_value_id;
            },
            submit() {
                if(util.isEmpty(this.model.category_id)) {
                    this.$message.warning("请选择供应品类！");
                    return;
                }
                if(!this.isPriceEmpty && util.isEmpty(this.minprice)) {
                    this.$message.warning("请输入最低价！");
                    return;
                }
                var reg = /(^[0-9]{1,9}$)|(^[0-9]{1,8}[\\.]{1}[0-9]{1,2}$)/;
                if(!this.isPriceEmpty && !reg.test(this.minprice)) {
                    this.$message.warning("最低价输入有误！");
                    return;
                }
                if(!util.isEmpty(this.maxprice) && !reg.test(this.maxprice)) {
                    this.$message.warning("最高价输入有误！");
                    return;
                }
                if(!this.isPriceEmpty && parseFloat(this.minprice) == 0) {
                    this.$message.warning("最低价需大于0！");
                    return;
                }
                if(!util.isEmpty(this.maxprice) && !util.isEmpty(this.minprice)) {
                    let min = parseFloat(this.minprice);
                    let max = parseFloat(this.maxprice);
                    if(max < min) {
                        this.$message.warning("最高价不得低于最低价！");
                        return;
                    }
                }
                if(!this.isPriceEmpty && util.isEmpty(this.model.unit)) {
                    this.$message.warning("请选择价格单位！");
                    return;
                }
                if(util.isEmpty(this.model.province_code)) {
                    this.$message.warning("请选择所在地！");
                    return;
                }
                if(util.isEmpty(this.model.remark)) {
                    this.$message.warning("请输入商品描述！");
                    return;
                }
                var areacode = this.model.province_code;
                var areapath = ';' + this.model.province_code + ';';
                if(!util.isEmpty(this.model.city_code)) {
                    areacode = this.model.city_code;
                    areapath += this.model.city_code + ';';
                }
                if(!util.isEmpty(this.model.district_code)) {
                    areacode = this.model.district_code;
                    areapath += this.model.district_code + ';';
                }
                let price = '';
                if(this.isPriceEmpty) {
                    price = '面议';
                }
                else {
                    price = parseFloat(this.minprice);
                    if(!util.isEmpty(this.maxprice)) {
                        price += '-';
                        price += parseFloat(this.maxprice);
                    }
                }
                
                var params = {
                   category_id: this.model.category_id,
                   attr_value_id: this.model.attr_value_id,
                   price: price,
                   unit: this.isPriceEmpty ? '' : '元/' + this.model.unit,
                   image: this.model.image,
                   areacode: areacode,
                   areapath: areapath,
                   //tel: this.model.tel,
                   remark: this.model.remark
                };
                if(this.id>0) {
                    params.id = this.id;
                    editsupply(params).then(res => {
                        if(res.code == 0) {
                            this.$message.success("提交成功！");
                            location.href="/member/my_supply";
                        }
                        else {
                            this.$message.error("提交失败,请重试！");
                        }
                    });
                }
                else {
                    addsupply(params).then(res => {
                        if(res.code == 0) {
                            this.$message.success("提交成功！");
                            location.href="/member/my_supply";
                        }
                        else {
                            this.$message.error("提交失败,请重试！");
                        }
                    });
                }
            },
            handleSuccess(response, file, fileList){
                var img = {name:response.data.pic_name, url:Config.baseUrl + response.data.pic_path};
                this.model.image = response.data.pic_path;
                this.imgList.push(img);
                this.checkCount();
            },
            handleRemove(file, fileList) {
                var imgs = [];
                this.model.image = '';
                fileList.forEach(item => {
                    var img = this.imgList.filter(function (a) {
                        return a.name == item.name;
                    });  
                    if(img.length >0)
                    {
                        imgs.push(img[0]);
                    }             
                });
                this.imgList = imgs;
                this.checkCount();
            },
            beforeAvatarUpload(file) {
                if(file.type!='image/jpg' && file.type!='image/jpeg' && file.type!='image/png' && file.type!='image/gif' && file.type!='image/bmp') {
                    this.$message.error('请上传正确格式的图片!');
                    return false;
                }
                if(file.size / 1024 / 1024 > 5) {
                    this.$message.error('请上传不超过5MB大小的图片!');
                    return false;
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(file, fileList) {
			    this.$message.error('上传图片最大数量为'+this.imgCount+'张');
		    },
            checkCount() {
                if(this.imgList.length>=this.imgCount){
                    $('.el-icon-plus').parent().hide();
                }
                else {
                    $('.el-icon-plus').parent().show();
                }
            }
        },
        mounted() {

		},
    }
</script>